<template>
  <div class="container" ref="container" :class="isDistributioned ? 'scroll' : ''">
    <div class="scroll_div" ref="scroll_div">
      <div class="header">
        <div class="yaoyiyao" @click="toDistribution"></div>
      </div>
      <div class="table_box" v-if="isDistributioned">
        <div class="table_tit"></div>
        <el-table border id="table" class="tableStyle" stripe :header-row-style="{ height: '44px'}" v-loading="tableLoading" :header-cell-style="tableHeaderColor" :data="dataList" :height="445" :row-style="rowStyle">
          <el-table-column :label="'选展位时段：'+sd" align="center">
            <template v-for="item in 4">
              <el-table-column :key="item" show-overflow-tooltip min-width="25%" align="center">
                <template slot-scope="scope">
                  {{scope.row[item-1] ? scope.row[item-1].qymc : ""}}
                </template>
              </el-table-column>
            </template>
          </el-table-column>
        </el-table>
        <div class="cur_page">
          <el-pagination 
            v-if="dataList.length > 0"
            @current-change="currentPageChange" 
            :current-page="currentPage" 
            :page-size="pageSize"
            background
            layout="prev, pager, next, jumper"
            :total=parseInt(total)>
          </el-pagination>
        </div>
      </div>
    </div>
    <s-loading v-if="loading"></s-loading>
  </div>
</template>

<script>
import paginator from '@/components/paginator'
import sLoading from './loading.vue'
export default {
  components: {
    paginator,
    sLoading
  },
  data () {
    return {
      dataList: [],
      // 总条数
      total: 0,
      //显示加载中样
      loading: false,
      //当前页
      currentPage: 1,
      //分页大小
      pageSize: 40,
      // 总分页
      allPage: 0,
      //表高度变量
      tableheight: this.CONSTANT.tableheight10,
      nowTime: "",
      // 是否摇号出结果
      isDistributioned: false,
      loading: false,
      pageTimer: null,
      sd: "",
      tableLoading: false,
      jljsnum: 0,
    }
  },
  created () {
    // this.getDataList()
  },
  watch: {
    currentPage: {
      handler (val, oldVal) {
        this.getDataList()
      }
    }
  },
  beforeDestroy () {
    if (this.pageTimer) {
      clearTimeout(this.pageTimer)
    }
  },
  methods: {
    getNowTime () {
      let date = new Date()
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = date.getDate()
      let h = date.getHours()
      m = m < 10 ? "0" + m : m
      d = d < 10 ? "0" + d : d
      this.nowTime = y + "年" + m + "月" + d + "日" + h + "时"
    },
    getDataList () {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        reserve1: 1,
        jljsnum: this.jljsnum
      }
      this.tableLoading = true
      this.$axios.post("zwtime/NewdoSearchListByVO", param).then(res => {
        this.tableLoading = false
        if (res.data.code === "00000000") {
          this.dataList = this.splitArr(res.data.result, 4)
          this.allPage = res.data.result[0].newpageNum;
          this.total = res.data.result[0].newpageNum * 40
          this.sd = res.data.result[0].kssjtwo + ' ~ ' + res.data.result[0].jssjtwo
          this.jljsnum = res.data.result[0].newpageNum
          console.log(this.currentPage, this.allPage);
          if (this.currentPage < this.allPage) {
            if (this.pageTimer) {
              clearTimeout(this.pageTimer)
            }
            this.pageTimer = setTimeout(() => {
              this.currentPage++
            }, 5000)
          } else {
            console.log(222);
            if (this.pageTimer) {
              clearTimeout(this.pageTimer)
            }
            this.pageTimer = setTimeout(() => {
              this.currentPage = 1
            }, 5000)
          }
        }
      })
    },
    /**
     * 分割数组创建二维数组封装
     * @param data 数组
     * @param senArrLen 需要分割成子数组的长度
     */
    splitArr(data, senArrLen) {
        //处理成len个一组的数据
        let data_len = data.length;
        let arrOuter_len = data_len % senArrLen === 0 ? data_len / senArrLen : parseInt((data_len /
            senArrLen) + '') + 1;
        let arrSec_len = data_len > senArrLen ? senArrLen : data_len; //内层数组的长度
        let arrOuter = new Array(arrOuter_len); //最外层数组
        let arrOuter_index = 0; //外层数组的子元素下标
        // console.log(data_len % len);
        for (let i = 0; i < data_len; i++) {
            if (i % senArrLen === 0) {
                arrOuter_index++;
                let len = arrSec_len * arrOuter_index;
                //将内层数组的长度最小取决于数据长度对len取余，平时最内层由下面赋值决定
                arrOuter[arrOuter_index - 1] = new Array(data_len % senArrLen);
                if (arrOuter_index === arrOuter_len) //最后一组
                    data_len % senArrLen === 0 ?
                    len = data_len % senArrLen + senArrLen * arrOuter_index :
                    len = data_len % senArrLen + senArrLen * (arrOuter_index - 1);
                let arrSec_index = 0; //第二层数组的索引
                for (let k = i; k < len; k++) { //第一层数组的开始取决于第二层数组长度*当前第一层的索引
                    arrOuter[arrOuter_index - 1][arrSec_index] = data[k];
                    arrSec_index++;
                }
            }
        }
        // console.log(arrOuter);
        return arrOuter
    },
    toDistribution () {
      let timeOut = null
      if (timeOut) {
        clearTimeout(timeOut)
      } else {
        if (!this.isDistributioned) {
          this.loading = true
          timeOut = setTimeout(() => {
            this.loading = false
            this.isDistributioned = true
            this.$nextTick(() => {
              this.$refs.container.scrollTop = document.body.offsetHeight
              this.getDataList()
              this.$axios.get("zwtime/sendMessage?reserve1=1").then(res => {})
            })
          }, 3000);
        } else {
          this.$nextTick(() => {
            this.$refs.container.scrollTop = document.body.offsetHeight
          })
        }
      }
      // this.loading = true
      // let param = {
      //   reserve1: 1
      // }
      // this.$axios.post("zwtime/yh", param).then(res => {
      //   this.loading = false
      //   if (res.data.code === "00000000") {
      //     this.getDataList()
      //     this.$axios.get("zwtime/sendMessage?reserve1=1").then(res => {})
      //   } else {
      //     this.$message.error("摇号失败，请稍后再试")
      //   }
      // }).catch(err => {
      //   this.$message.error("摇号失败，请稍后再试")
      // })
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        this.$nextTick(() => {
          if (document.getElementsByClassName(column.id).length !== 0) {
            document.getElementsByClassName(column.id)[0].setAttribute("rowspan", 1);
            return false;
          }
        });
        return column;
      }
    },
    currentPageChange (val) {
      if (this.currentPage != val) {
        this.currentPage = val;
        // this.getDataList();
        if (this.pageTimer) {
          clearTimeout(this.pageTimer)
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .scroll {
    overflow-y: scroll;
  }
  .container {
    width: 100vw;
    height: 100vh;
    background-color: #f6faff;
    .scroll_div {
      width: 100%;
      min-height: 100vh;
      padding-top: 30px;
      background: url(/static/images/lottery/bg_01.png) no-repeat;
      background-size: 100% ;
    }
    
    .header {
      width: 840px;
      height: 582px;
      margin: 0 auto;
      background: url(/static/images/lottery/bg_02.png) no-repeat;
      background-size: 100%;
      position: relative;
    }
    .yaoyiyao {
      width: 270px;
      height: 87px;
      background: url(/static/images/lottery/btn_yaohao.png) no-repeat;
      background-size: 100% 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -40px;
      cursor: pointer;
    }
    .table_box {
      width: 100%;
      margin-top: calc(100vh - 612px);
      min-height: 100vh;
      padding-top: 20px;
      .table_tit {
        width: 1000px;
        height: 162px;
        background: url(/static/images/lottery/pic_title1.png) no-repeat;
        background-size: 100% 100%;
        margin: 20px auto;
      }
      .tableStyle {
        width: 1000px;
        margin: 0 auto;
        background: url(/static/images/lottery/bg_table.png) no-repeat;
        background-size: 100% 100%;
      }
      .cur_page {
        margin-top: 20px;
        display: flex;
        justify-content: center;
      }
    }
    /deep/ .el-table__header-wrapper {
      height: 44px !important;
    }
    // /deep/ .el-table__empty-text {
    //   width: 100%;
    //   height: 40px;
    //   line-height: 40px;
    //   background: url(/static/images/lottery/bg_ddjg.png) no-repeat;
    //   background-size: 100% 100%;
    //   font-size: 18px;
    //   color: #fff;
    //   display: flex;
    //   justify-content: center;
    //   align-items: center;
    //   &::before {
    //     content: "";
    //     display: inline-block;
    //     width: 28px;
    //     height: 28px;
    //     background: url(/static/images/lottery/icn_wait.png) no-repeat center center;
    //     background-size: 28px 28px;
    //     margin-right: 10px;
    //   }
    // }

    /deep/ .el-table__header th, /deep/ .el-table__header tr {
      background-color: #fff2e9;
      // border-top: 3px solid #2452ff;
      border-image-source: url(/static/images/lottery/pic_tablehead.png);
      border-image-slice: 4;
      border-image-outset: 0 0 4 4;
      border-image-width: 4px;
      border-image-repeat: repeat;
      height: 41px;
      font-size: 14px;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #333;
    }
    /deep/ .el-table__row {
      background: rgba(#fff, .1);
    }
    /deep/ .el-table__row.el-table__row--striped {
      background: rgba(#FAFAFA, .1);
    }
    // /deep/ .el-table td, /deep/ .el-table th.is-leaf {
    //   border-right: none;
    // }
  }


  @media screen and (max-width: 1536px) {
    .header {
      width: 630px !important;
      height: 436px !important;
      .yaoyiyao {
        width: 202px !important;
        height: 65px !important;
        bottom: -30px !important;
      }
    }
  }
  @media screen and (max-width: 1280px) {
    .header {
      width: 420px !important;
      height: 291px !important;
      .yaoyiyao {
        width: 135px !important;
        height: 44px !important;
        bottom: -20px !important;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/lottery/lotteries.vue